import { createSlice, current } from '@reduxjs/toolkit';
import { message as toaster } from 'antd';
import { sortBy, orderBy, groupBy, first, toLower, toUpper, uniqBy } from 'lodash';
import { setselectedSalesMan } from 'store/userSlice';
import { getQueryParams } from 'utils';
import { API } from 'api';

function salesmanName(first_name = '') {
	return toUpper(toLower(first(first_name)));
}

function orderSalesMen(payload) {
	const orderedSalesMenList = orderBy(payload, ['first_name'], ['asc']);
	const groupedSalesMenList = groupBy(orderedSalesMenList, (man) =>
		salesmanName(man?.first_name)
	);
	const brandNames = uniqBy(payload, 'brand_name');

	return { orderedSalesMenList, groupedSalesMenList, brandNames };
}

function findValue(data, search) {
	/**
	 * change key and searched word to lower case and find the seached data
	 */
	return data?.toLowerCase()?.includes(search?.toLowerCase());
}

export function filterInvoices(invoices, search) {
	/**
	 * Find searched word in invoice store namd and invoice id
	 */
	// const storeName = invoices?.find(
	// 	(item) => item?.invoice_no.toLowerCase() === search.toLowerCase()
	// )?.store_name;

	// return invoices?.filter((item) =>
	// 	storeName ? findValue(item?.store_name, storeName) : findValue(item?.store_name, search)
	// );

	return invoices?.filter(
		(item) => findValue(item?.store_name, search) || findValue(item?.invoice_no, search)
	);
}

export function filterSalesMen(salesMen, search) {
	/**
	 * Find searched word in sales men name and mobile number or in invoice numbers
	 */
	return salesMen?.filter(
		(item) =>
			findValue(item?.first_name, search) ||
			findValue(item?.mobile, search) ||
			findValue(item?.invoice_numbers, search)
	);
}

const initialState = {
	invoices: [],
	receivedInvoiceList: [],
	delegationInvoiceList: [],
	// filtering invoices based on search value
	filteredInvoices: [],
	filteredReceivedInvoices: [],
	filteredDelegateInvoices: [],
	//
	invoiceSearch: '',
	banks: [],
	reasons: [],
	dashboard: {
		bill_back: 1,
		no_bill_back: 1,
		cash: 0,
		neft: 0,
		upi: 0,
		cheque: 0,
		total: 0,
	},
	denomination: {
		two_thousand: 0,
		five_hundred: 0,
		two_hundred: 0,
		hundred: 0,
		fifty: 0,
		twenty: 0,
		ten: 0,
		five: 0,
		coins: 0,
	},
	salesMen: [],
	// filtering salesman based on search value for additional resource
	filteredsalesMen: [],
	salesMenSearch: '',
	salesMenGrouped: {},
	brandNames: [],
	brandCheckList: [],
	assignedInvoices: [],
	filteredAssignedInvoices: [],
	pastInvoice: [],
	additionalFilter: false,
	isNoInvoicesMen: false,
	pastInvoiceState: true,
	chosenColor: '',
	salesMenDetail: '',
	checkAll: false,
	isInvoiceOpen: false,
	isAccordionOpen: false,
	isFormOpen: false,
	deligationStatus: false,
	panelKey: ['1'],
};

export const invoiceSlice = createSlice({
	name: 'invoice',
	initialState,
	reducers: {
		setInvoices: (state, { payload }) => {
			/**
			 * For furture purpose added isOpen key to add invoices in local,
			 * for to show and hide the invoice form using redux,
			 * but currently not used this logic
			 */
			const data = sortBy(
				payload.map((item) => ({ ...item, isOpen: false })),
				['status']
			).reverse();

			state.invoices = data;
			state.filteredInvoices = data;
		},
		updateInvoices: (state, { payload }) => {
			// this below logic is not working as expected so, din't invoke this function
			const data = sortBy(
				current(state?.invoices)?.map(
					(invoice) =>
						invoice.id === payload.id // Loop through the array to find the invoice want to modify
							? payload
							: invoice // update the new invoice state and then modify it. Else return the old invoice.
				),
				['status']
			).reverse();

			state.invoices = data;
			/**
			 * After save, update, clear invoices check if data on invoiceSearch,
			 * if yes filter the invoice list based on that,
			 * else so all invoices
			 */
			if (state?.invoiceSearch !== '') {
				const newData = filterInvoices(data, state?.invoiceSearch);

				state.filteredInvoices = newData;
			} else {
				state.filteredInvoices = data;
			}
		},
		setFilteredInvoices: (state, { payload }) => {
			const data = sortBy(payload, ['status']).reverse();

			state.filteredInvoices = data;
		},
		setFilteredReceivedInvoices: (state, { payload }) => {
			const data = sortBy(payload, ['status']).reverse();

			state.filteredReceivedInvoices = data;
		},
		setFilteredDelegateInvoices: (state, { payload }) => {
			const data = sortBy(payload, ['status']).reverse();

			state.filteredDelegateInvoices = data;
		},
		setFilteredAssginedInvoices: (state, { payload }) => {
			state.filteredAssignedInvoices = payload;
		},
		setInvoiceSearch: (state, { payload }) => {
			state.invoiceSearch = payload;
		},
		setReceivedInvoices: (state, { payload }) => {
			state.receivedInvoiceList = payload;
			state.filteredReceivedInvoices = payload;
		},
		//
		setBanks: (state, { payload }) => {
			state.banks = payload;
		},
		setReasons: (state, { payload }) => {
			state.reasons = payload;
		},
		setDashboard: (state, { payload }) => {
			state.dashboard = payload;
		},
		setDenomination: (state, { payload }) => {
			state.denomination = payload;
		},
		setSalesMen: (state, { payload }) => {
			const { orderedSalesMenList, groupedSalesMenList, brandNames } = orderSalesMen(payload);

			state.salesMenGrouped = groupedSalesMenList;
			state.brandNames = brandNames;
			state.salesMen = orderedSalesMenList;
			state.filteredsalesMen = orderedSalesMenList;
		},
		setFilteredSalesMen: (state, { payload }) => {
			const { orderedSalesMenList, groupedSalesMenList, brandNames } = orderSalesMen(payload);

			state.salesMenGrouped = groupedSalesMenList;
			state.brandNames = brandNames;
			state.filteredsalesMen = orderedSalesMenList;
		},
		setSalesMenSearch: (state, { payload = '' }) => {
			state.salesMenSearch = payload;
		},
		setIsInvoiceOpen: (state, { payload }) => {
			state.isInvoiceOpen = payload;
		},
		setIsAccordionOpen: (state, { payload }) => {
			state.isAccordionOpen = payload;
		},
		setIsFormOpen: (state, { payload }) => {
			state.isFormOpen = payload;
		},
		brandBasedFilter: (state, { payload }) => {
			const filtered = state?.filteredsalesMen?.filter(
				(item) => item?.brand_id === Number(payload)
			);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		getNoInvoiceMen: (state) => {
			const filtered = state?.filteredsalesMen?.filter((item) => item?.invoices === 0);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		setIsNoInvoicesMen: (state, { payload }) => {
			state.isNoInvoicesMen = payload;
		},
		setAdditionalFilter: (state, { payload }) => {
			state.additionalFilter = payload;
		},
		setChosenColor: (state, { payload }) => {
			state.chosenColor = payload;
		},
		multipleStatusFilter: (state) => {
			const filtered = state?.filteredsalesMen?.filter(
				(item) =>
					item?.invoices !== 0 ||
					item?.pending_invoices !== 0 ||
					item?.completed_invoices !== 0
			);
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		singleStatusFilter: (state, { payload }) => {
			let filtered = [];

			// blue dot
			if (payload === 1) {
				filtered = state?.filteredsalesMen?.filter(
					(item) => item?.invoices > 0 && item?.invoices === item?.pending_invoices
				);
			}

			// orange dot
			if (payload === 2) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.invoices >= item?.completed_invoices &&
						item?.salesman_filled > 0 &&
						item?.invoices !== item?.salesman_filled
				);
			}

			// green dot
			if (payload === 3) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.invoices > 0 &&
						item?.invoices === item?.completed_invoices &&
						item?.invoices === item?.salesman_filled
				);
			}

			// red-border dot
			if (payload === 4) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.additional_resource_filled > 0 &&
						item?.salesman_filled === 0 &&
						item?.invoices !== item?.additional_resource_filled
				);
			}
			// red dot
			if (payload === 5) {
				filtered = state?.filteredsalesMen?.filter(
					(item) =>
						item?.additional_resource_filled > 0 &&
						item?.invoices === item?.completed_invoices
				);
			}
			const grouped = groupBy(filtered, (man) => salesmanName(man?.first_name));

			state.salesMenGrouped = grouped;
		},
		setDeligationStatus: (state, { payload }) => {
			state.deligationStatus = payload;
		},
		setAssignedInvoices: (state, { payload }) => {
			state.assignedInvoices = payload;
			state.filteredAssignedInvoices = payload;
		},
		setBrandCheckList: (state, { payload }) => {
			if (state.brandCheckList.length > 0 && state.brandCheckList.includes(payload)) {
				state.brandCheckList = state.brandCheckList.filter(
					(brandId) => brandId !== payload
				);
				state.checkAll = false;
			} else {
				state.brandCheckList.push(payload);
			}
		},
		setAllBrandList: (state, { payload }) => {
			if (!state.checkAll && payload.length > 0) {
				state.brandCheckList = [];
				payload.map(
					(invoice) =>
						invoice.status === 'Pending' && state.brandCheckList.push(invoice.id)
				);
				state.checkAll = true;
			} else {
				state.brandCheckList = [];
				state.checkAll = false;
			}
		},
		setDelegationData: (state, { payload }) => {
			const invoiceFilter = payload.filter(
				(s) => !state.filteredInvoices.find((invoice) => invoice?.id === s?.id)
			);

			const receivedFilter = invoiceFilter.filter(
				(s) => !state.filteredReceivedInvoices.find((invoice) => invoice?.id === s?.id)
			);

			state.delegationInvoiceList = receivedFilter;
			state.filteredDelegateInvoices = receivedFilter;
		},
		setSalesMenDetail: (state, { payload }) => {
			state.salesMenDetail = payload;
		},
		setPastInvoices: (state, { payload }) => {
			state.pastInvoice = payload;
			if (payload.length === 0) {
				state.pastInvoiceState = false;
			} else {
				state.pastInvoiceState = true;
			}
		},
		clearPastInvoiceState: (state) => {
			state.pastInvoiceState = true;
		},
		setPanelKey: (state, { payload }) => {
			state.panelKey = payload;
		},
		clearCheckList: (state) => {
			state.brandCheckList = [];
			state.salesMenDetail = '';
			state.checkAll = false;
		},
	},
});

export const {
	setInvoices,
	updateInvoices,
	setBanks,
	setReasons,
	setDashboard,
	setDenomination,
	setSalesMen,
	setFilteredInvoices,
	setFilteredReceivedInvoices,
	setFilteredDelegateInvoices,
	setFilteredAssginedInvoices,
	setInvoiceSearch,
	setIsInvoiceOpen,
	setIsAccordionOpen,
	setIsFormOpen,
	brandBasedFilter,
	setIsNoInvoicesMen,
	setAdditionalFilter,
	getNoInvoiceMen,
	setChosenColor,
	multipleStatusFilter,
	singleStatusFilter,
	setDeligationStatus,
	setBrandCheckList,
	setSalesMenDetail,
	setFilteredSalesMen,
	setDelegationData,
	setSalesMenSearch,
	setAssignedInvoices,
	setAllBrandList,
	setPastInvoices,
	clearCheckList,
	clearPastInvoiceState,
	setReceivedInvoices,
	setPanelKey,
} = invoiceSlice.actions;

export const dashboardDetails = (salesmanId) => async (dispatch, getState) => {
	const url = '/dashboard/details';
	const invoice_date = getState()?.app?.invoiceDate;
	const salesmanIdTemp = getQueryParams('salesmanId');

	const CREDENTIALS = {
		url,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId || salesmanIdTemp,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setDashboard(response.data));

		return response;
	});
};

export const getDelegateList = () => async (dispatch, getState) => {
	const invoice_date = getState()?.app?.invoiceDate;
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const CREDENTIALS = {
		url: `/invoices/delegate`,
		queryParams: {
			invoice_date,
			salesman_id: selectedSalesMan,
		},
	};

	return API.common(CREDENTIALS).then((response) => dispatch(setDelegationData(response.data)));
};

export const getInvoices = (salesmanId) => async (dispatch, getState) => {
	dispatch(setInvoiceSearch(' '));
	dispatch(setIsInvoiceOpen(false));
	// const url = salesmanId ? `/invoices?salesman_id=${salesmanId}` : '/invoices';
	const url = '/invoices';
	const invoice_date = getState()?.app?.invoiceDate;
	const salesmanIdTemp = getQueryParams('salesmanId');

	const CREDENTIALS = {
		url,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId || salesmanIdTemp,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setInvoices(response.data));
		// dispatch(dashboardDetails(salesmanId));

		return response;
	});
};

export const getDeliveryDate = () => async (dispatch, getState) => {
	console.log(getState);
	const invoice_date = getState()?.app?.invoiceDate;
	const storeID = getQueryParams('storeId');
	const salesmanId = getQueryParams('salesmanId');
	let url;

	if (salesmanId) {
		url = `invoices/collections/delivery-date?store_id=${storeID}&collection_date=${invoice_date}&salesman_id=${salesmanId}`;
	} else {
		url = `invoices/collections/delivery-date?store_id=${storeID}&collection_date=${invoice_date}`;
	}

	const CREDENTIALS = {
		url,
	};

	return API.common(CREDENTIALS).then((response) => {
		console.log(response);

		return response;
	});
};
export const getReceivedInvoices = (salesmanId) => (dispatch, getState) => {
	// const url = salesmanId
	// 	? `/invoices?show_to=Assigned&salesman_id=${salesmanId}`
	// 	: `/invoices?show_to=Assigned`;
	const url = '/invoices';
	const invoice_date = getState()?.app?.invoiceDate;
	const CREDENTIALS = {
		url,
		queryParams: {
			invoice_date,
			show_to: 'Assigned',
			salesman_id: salesmanId,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setReceivedInvoices(response?.data));

		return response?.data;
	});
};

export const getAssignedInvoices = (data) => async (dispatch, getState) => {
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const CREDENTIALS = {
		url: `/invoices/assigned`,
		queryParams: {
			salesman_id: data ? data?.from_salesman_id : 0,
			from_salesman_id: selectedSalesMan || undefined,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		const resData = uniqBy(response.data, 'id');

		dispatch(setAssignedInvoices(resData));

		return response;
	});
};

export const getRejectedInvoices = (data) => async (dispatch, getState) => {
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const CREDENTIALS = {
		url: `/invoices/delegate/rejected`,
		queryParams: {
			salesman_id: data?.from_salesman_id,
			from_salesman_id: selectedSalesMan || undefined,
			collection_invoice_id:
				data?.data?.collection_invoice_id || data?.data?.rejected_invoice_id,
		},
	};

	// eslint-disable-next-line sonarjs/no-identical-functions
	return API.common(CREDENTIALS).then((response) => {
		const resData = uniqBy(response.data, 'id');

		dispatch(setAssignedInvoices(resData));

		return response;
	});
};
export const acceptAssignedInvoice = (brandId, invoiceDetails) => async (dispatch) => {
	const CREDENTIALS = {
		url: `/invoices/assigned`,
		method: 'put',
		data: {
			collection_invoice_id: brandId,
			salesman_id: invoiceDetails?.from_salesman_id,
		},
	};

	return API.common(CREDENTIALS).then(() => {
		toaster.success('Invoice Accepted success');
		dispatch(getReceivedInvoices(invoiceDetails?.from_salesman_id));
	});
};

export const rejectAssignedInvoice = (invoiceDetails) => async () => {
	const CREDENTIALS = {
		url: `/invoices/assigned`,
		method: 'delete',
		queryParams: {
			salesman_id: invoiceDetails?.from_salesman_id,
		},
	};

	return API.common(CREDENTIALS).then(() => {
		toaster.success('Invoice Rejected success');
	});
};

export const updatePastInvoice = (data) => async () => {
	const CREDENTIALS = {
		url: `/invoices/past`,
		method: 'post',
		data: { invoice_id: data },
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const searchPastInvoice = (data) => async (dispatch, getState) => {
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const CREDENTIALS = {
		url: `/invoices/past`,
		queryParams: {
			invoice_number: data,
			salesman_id: selectedSalesMan,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		if (response.data.length > 0) {
			dispatch(updatePastInvoice(response?.data[0]?.id));
		}
		dispatch(setPastInvoices(response?.data));

		return response;
	});
};

export const saveAllInvoicesComplete = (values, setErrors) => async (dispatch, getState) => {
	dispatch(setIsInvoiceOpen(false));
	const CREDENTIALS = {
		url: `/invoices/complete`,
		method: 'post',
		data: values,
		setErrors,
	};

	return API.common(CREDENTIALS).then((response) => {
		const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

		console.log(selectedSalesMan);

		// dispatch(dashboardDetails(selectedSalesMan));

		return response;
	});
};

export const saveInvoice =
	(id, values, setErrors, isAmortize = false) =>
	async (dispatch, getState) => {
		dispatch(setIsInvoiceOpen(false));
		let details = {
			method: 'post',
			message: 'saved',
		};

		/**
		 * on Amortization don't make api call as put call
		 */
		if (values?.previousStatus !== 'Pending' && !isAmortize) {
			details = {
				method: 'put',
				message: 'updated',
			};
		}
		const CREDENTIALS = {
			// url: `/invoices/${id}/complete`,
			url: `/invoices/complete`,
			method: details.method,
			data: values,
			setErrors,
		};

		return API.common(CREDENTIALS).then((response) => {
			// dispatch(updateInvoices(response.data));
			const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

			console.log(selectedSalesMan);

			// dispatch(dashboardDetails(selectedSalesMan));
			if (!isAmortize) {
				toaster.success(`Invoice ${details.message} success`);
			}

			return response;
		});
	};

export const clearInvoice =
	(
		id,
		showSuccess = true,
		data = {
			payment: [],
			status: undefined,
		}
	) =>
	async (dispatch, getState) => {
		/**
		 * Clear invoice with single invoice id
		 */
		dispatch(setIsInvoiceOpen(false));

		const values = { payment: [] };

		if (data?.payment?.length > 0) {
			values.payment = data?.payment;
			values.status = data?.status;
		}

		const CREDENTIALS = {
			url: `/invoices/${id}/clear`,
			method: 'put',
			data: values,
		};

		return API.common(CREDENTIALS).then((response) => {
			// dispatch(updateInvoices(response.data));
			const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

			console.log(selectedSalesMan);

			// dispatch(dashboardDetails(selectedSalesMan));
			if (showSuccess) {
				toaster.success('Invoice cleared success');
			}

			return response;
		});
	};

export const getAmortizeLogic = (values) => async () => {
	/**
	 * Get amortize split data from Backend
	 */
	const CREDENTIALS = {
		url: `/invoices/amortize`,
		method: 'post',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const clearAllInvoices = (values) => async () => {
	/**
	 * New way to clear all invoices with single api call, in data we will send invoices ids
	 */
	const CREDENTIALS = {
		url: `/invoices/clear-all`,
		method: 'put',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const reassignInvoice = (invoiceId) => (dispatch) => {
	const CREDENTIALS = {
		url: `/invoices/assigned/reassign`,
		method: 'post',
		data: {
			collection_invoice_id: invoiceId,
		},
	};

	return API.common(CREDENTIALS).then(() => {
		dispatch(getInvoices());
		dispatch(getAssignedInvoices());
		dispatch(getReceivedInvoices());
	});
};

export const delegateInvoice = (state) => async (dispatch, getState) => {
	const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

	const data = {
		collection_invoice_id: state.brandCheckList,
		salesman_id: state.salesMenDetail.id,
	};

	if (selectedSalesMan) {
		data.from_salesman_id = selectedSalesMan;
	}

	const CREDENTIALS = {
		url: `/invoices/delegate`,
		method: 'post',
		data,
	};

	return API.common(CREDENTIALS).then((response) => response);
};

export const getBanks = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `/banks`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setBanks(response.data));

		return response;
	});
};

export const getReasons = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `/reasons`,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setReasons(response.data));

		return response;
	});
};

export const getDenominations = (salesmanId) => async (dispatch, getState) => {
	const url = salesmanId ? `/denominations?salesman_id=${salesmanId}` : '/denominations';
	const invoice_date = getState()?.app?.invoiceDate;

	const CREDENTIALS = {
		url,
		queryParams: {
			invoice_date,
			salesman_id: salesmanId,
		},
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setDenomination(response.data));

		return response;
	});
};

export const saveDenominations = (values) => async (dispatch) => {
	const CREDENTIALS = {
		url: `/denominations`,
		method: 'post',
		data: values,
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(setDenomination(response.data));
		toaster.success('Denomination updated success');

		return response;
	});
};

export const makeAllBillBack = () => async (dispatch) => {
	const CREDENTIALS = {
		url: `/invoices/bill-back`,
		method: 'put',
	};

	return API.common(CREDENTIALS).then((response) => {
		dispatch(getInvoices());
		toaster.success('All Invoices Set as Bill Back');

		return response;
	});
};

export const getAlreadyPaidUPIList =
	({ store_id, salesmanId }) =>
	async (dispatch) => {
		const CREDENTIALS = {
			url: `/invoices/upi-list`,
			method: 'get',
			queryParams: {
				store_id,
				salesman_id: salesmanId,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			dispatch(getInvoices());

			return response;
		});
	};

export const getSalesMen =
	(clearselectedSalesMan = false) =>
	async (dispatch, getState) => {
		const selectedSalesMan = getState()?.user?.selectedSalesMan.id || undefined;

		/**
		 * Before sales men list call, reset already selected sales man
		 */
		if (clearselectedSalesMan) {
			dispatch(setselectedSalesMan({}));
		}
		const CREDENTIALS = {
			url: `/sales-men`,
			queryParams: {
				salesman_id: selectedSalesMan,
			},
		};

		return API.common(CREDENTIALS).then((response) => {
			dispatch(setSalesMenSearch());
			dispatch(setSalesMen(response.data));

			return response;
		});
	};

export const getUpiReferenceNumbers =
	({ store_id, salesman_id, query, amount }) =>
	async () => {
		const CREDENTIALS = {
			url: '/online-transactions',
			queryParams: {
				amount,
				query,
				store_id,
				salesman_id,
				type: 'UPI',
			},
		};

		return API.common(CREDENTIALS).then((response) => response.data);
	};

export default invoiceSlice.reducer;
